import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import SignupProgress from "../../../Components/SignupProgress";
import { Check } from "lucide-react";
import { images } from "../../../Assets/images";

const CreateAccount5 = () => {
  const {
    signupData,
    updateSignupData,
    createAccountScreenFour,
    translatedLabels,
    logoUrl,
    getWellnessCat,
    wellnessCat,
    is4Life,
  } = useContext(GlobalContext);

  useEffect(() => {
    getWellnessCat();
  }, [getWellnessCat]);

  const authLabel = translatedLabels?.auth;
  const commonLabel = translatedLabels?.common;
  const screenLabels = translatedLabels?.common;

  const selectedArray = Array.isArray(signupData?.wellnessCategory)
    ? signupData.wellnessCategory
    : [];

  const handleCheckboxChange = (uuid) => {
    let updatedSelection = [...selectedArray];

    if (updatedSelection.includes(uuid)) {
      updatedSelection = updatedSelection.filter((id) => id !== uuid);
    } else {
      if (updatedSelection.length >= 3) return; // max 3
      updatedSelection.push(uuid);
    }

    updateSignupData("wellnessCategory", updatedSelection);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    createAccountScreenFour();
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-center">
        <div className="app-logo">
          <img
            src={logoUrl || images.appLogo}
            alt="app-logo"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = images.appLogo;
            }}
          />
        </div>
      </div>

      <SignupProgress currentStep={is4Life ? 4 : 3} />

      <h4 className="mt-3 survey-heading">
        {commonLabel?.wellness_categories?.label_value ||
          "What areas of your wellness would you most like to support? (Select up to 3)"}{" "}
      </h4>

      <form onSubmit={handleSubmit}>
        <div className="d-flex flex-column gap-3 mt-4 px-3">
          {wellnessCat?.other_list?.map((cat) => {
            const isSelected = selectedArray.includes(cat.uuid);

            const normalize = (str) =>
              str
                ?.toLowerCase()
                .replace(/&/g, "")
                .replace(/[^a-z0-9\s_]/g, "")
                .replace(/\s+/g, "_")
                .replace(/_+/g, "_")
                .trim();

            const normalizedCatName = normalize(cat.category_name);

            const allKeys = [
              ...Object.keys(screenLabels || {}),
              ...Object.keys(authLabel || {}),
            ];

            const matchedKey = allKeys.find(
              (key) => normalize(key) === normalizedCatName,
            );

            const label =
              screenLabels?.[matchedKey]?.label_value ||
              authLabel?.[matchedKey]?.label_value ||
              cat.category_name;
            return (
              <label
                key={cat.uuid}
                className="d-flex align-items-center"
                style={{ cursor: "pointer" }}
              >
                <input
                  type="checkbox"
                  className="d-none"
                  checked={isSelected}
                  onChange={() => handleCheckboxChange(cat.uuid)}
                />

                <div
                  className="d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    border: `1px solid var(--primaryColor)`,
                    backgroundColor: isSelected
                      ? "var(--primaryColor)"
                      : "transparent",
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  {isSelected && (
                    <Check size={16} color="white" strokeWidth={3} />
                  )}
                </div>

                <span className="fw-semibold">{label}</span>
              </label>
            );
          })}
        </div>

        <div className="mt-5 text-center">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={selectedArray.length === 0}
          >
            {authLabel?.next?.label_value || "Next"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateAccount5;
